<template>
    <div class="trending-header">
        <div class="col-xs-6 p-h-5">
            <div class="button btn btn-outline btn-block filter1" @click="changeOrder()">
                <span class="sort">{{ getFilter }}</span>
                <i class="iconify icon:ic:baseline-keyboard-arrow-down"></i>
            </div>
        </div>
        <div class="col-xs-6 p-h-5">
            <div class="button btn btn-outline btn-block filter2" @click="openFilters()">
                <span class="provider">{{ getProvider }}</span><br>
                <span class="period">{{ getPeriod }}</span>
                <i class="iconify icon:ic:outline-insert-chart"></i>
            </div>
        </div>

        <div :id="eid">
            <transition name="page-overlay">
                <div class="page-overlay trending-filters" v-if="showFilters" style="display: list-item; overflow: auto;">
                    <div class="container">
                        <div class="row">
                            <div class="col-xs-12">
                                <h3>Select Channel.</h3>

                                <ul>
                                    <li class="button" @click="provider = 'youtube'" :class="{active: provider == 'youtube'}"><img src="/img/web/song/statistics/youtube.svg" alt=""/> Youtube</li>
                                    <li class="button" @click="provider = 'soundcloud'" :class="{active: provider == 'soundcloud'}"><img src="/img/web/song/statistics/soundcloud.svg" alt=""/> Soundcloud</li>
                                    <li class="button" @click="provider = 'shazam'" :class="{active: provider == 'shazam'}"><img src="/img/web/song/statistics/shazam.svg" alt=""/> Shazam</li>
                                    <li class="button" @click="provider = 'spotify_plays_backstage'" :class="{active: provider == 'spotify_plays_backstage'}"><img src="/img/web/song/statistics/spotify.svg" alt=""/> Spotify</li>
                                    <li class="button" @click="provider = 'apple_music'" :class="{active: provider == 'apple_music'}"><img src="/img/web/song/statistics/apple_music.svg" alt=""/> Apple Music</li>
                                    <li class="button" @click="provider = 'warm_music'" :class="{active: provider == 'warm_music'}"><img src="/img/web/song/statistics/warm_music.svg" alt=""/> Radio</li>
                                </ul>

                                <h3>Select Time Interval.</h3>
                                <ul>
                                    <li class="button" @click="period = disableYesterday ? period : 'daily'" :class="{active: period == 'daily', disabled: disableYesterday}">Last 24h</li>
                                    <li class="button" @click="period = 'weekly'" :class="{active: period == 'weekly'}">Last 7 days</li>
                                    <li class="button" @click="period = 'monthly'" :class="{active: period == 'monthly'}">Last 30 days</li>
                                </ul>
                            </div>
                        </div>

                        <div class="col-xs-12 text-center m-t-16">
                            <div class="btn btn-round button" @click="setFilters()">DONE</div>
                        </div>
                    </div>
                </div>
            </transition>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            eid: "filter_overlay_"+ Math.random().toString(36).substr(2, 9),
            showFilters: false,
            filterKey: 'order_by_financial',
            period: 'daily',
            provider: 'youtube',
            initialPeriod: 'daily',
            initialProvider: 'youtube',
        }
    },

    mounted() {
        $(`#${this.eid}`).appendTo(".page-content");
    },

    methods: {
        changeOrder(){
            this.filterKey = this.filterKey == 'order_by_financial' ? 'order_by_evolution' : 'order_by_financial'; 

            var filter = {
                key: this.filterKey,
                value: `${this.provider}.${this.period}.desc`,
            };

            this.$parent.$emit('lineFilterUpdated', filter);
        },

        openFilters(){
            this.showFilters = true;
            this.$root.$emit('lockScroll');
            this.initialProvider = this.provider;
            this.initialPeriod = this.period;
        },

        setFilters() {
            this.showFilters = false;
            this.$root.$emit('unlockScroll');

            // send event only if changes happened
            if (this.provider != this.initialProvider || this.period != this.initialPeriod){
                this.$parent.$emit('trendingFilterUpdated', `${this.provider}.${this.period}.desc`);
            }
        },
    },

    computed: {
        getFilter(){
            switch (this.filterKey){
                case 'order_by_financial': return 'Top growth'; break;
                case 'order_by_evolution': return 'Evolution'; break;
            }
        },

        getPeriod(){
            switch (this.period){
                case 'daily': return 'Last 24h'; break;
                case 'weekly': return 'Last 7 days'; break;
                case 'monthly': return 'Last 30 days'; break;
            }
        },

        getProvider(){
            switch (this.provider){
                case 'youtube': return 'Youtube'; break;
                case 'soundcloud': return 'Soundcloud'; break;
                case 'shazam': return 'Shazam'; break;
                case 'spotify_plays_backstage': return 'Spotify'; break;
                case 'apple_music': return 'Apple Music'; break;
                case 'warm_music': return 'Radio'; break;
            }
        }        
    },

    watch: {
        provider(){
            if (['spotify_plays_backstage', 'apple_music'].indexOf(this.provider) > -1){
                this.disableYesterday = true;
                if (this.period == 'daily'){
                    this.period = 'weekly';
                }
            }else{
                this.disableYesterday = false;
            }
        }
    },

    beforeDestroy() {
        $(`#${this.eid}`).remove();
    }
}
</script>